import { Component, computed, ElementRef, OnInit, Optional, Output, signal, ViewChild } from "@angular/core"; import { Location } from "@angular/common";
import { MenuItem, LazyLoadEvent, TreeNode } from 'primeng/api';

// Extend TreeNode interface to include document property
interface FileTreeNode extends TreeNode {
    document?: DocumentEntite;
    type?: 'file' | 'folder' | 'dynamic-folder';
    parent?: TreeNode;
    folderPath?: string; // For dynamic folders
    isRootFolder?: boolean; // To distinguish root folders from dynamic ones
}
import { DocumentService } from '../../services/document-service';
import { ContexteService } from '../../services/contexte-service';
import { NavigationExtras, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Input, Signal, WritableSignal } from "@angular/core";
import { BaseComponent } from '../../base/base-component';
import { DonneesBaseService } from '../../services/donnees-base-service';
import { ProfilService } from '../../services/profil-service';
import { ActivatedRoute } from '@angular/router';
import { AppMainComponent } from '../../app.main.component';
import { MessageService } from 'primeng/api';
import { ETypeLien } from '../../entites/enums/type-lien-document';
import { DetailDocumentComponent } from './controles/detail-document.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DocumentEntite } from '../../entites/document';
import { ConfirmationService } from 'primeng/api';
import { Tree } from 'primeng/tree';
import { ETypeFichier } from 'src/app/entites/enums/type-fichier';
import { DataView, DataViewPageEvent } from 'primeng/dataview';
import { VideoPlayerComponent } from "src/app/controles/video-player.component";
import { HttpResponse } from "@angular/common/http";
import { PdfViewerComponent } from "src/app/controles/pdf-viewer.component";
import { HttpEventType } from "@angular/common/http";
import { NotificationService } from "src/app/services/notification-service";
import { ItemService } from "src/app/services/item-service";
import { lastValueFrom, map } from "rxjs";
import { Menu } from "primeng/menu";
import { RequeteAjouterDocuments } from "src/app/services/requetes/requete-ajouter-documents";
import { OverlayPanel } from "primeng/overlaypanel";
import { DocumentUpload, FichierUpload, ErrorUpload, VideoUpload, R2Upload } from "src/app/services/reponses/reponse-r2-presigned";
import { RequeteCompleterUploadR2 } from "src/app/services/requetes/requete-completer-upload-r2";
import { FichierCompleter } from "src/app/entites/fichier-completer";
import { TypeDocumentEntite } from "src/app/entites/type-document";
import { Sidebar, SidebarModule } from "primeng/sidebar";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { CalendarModule } from "primeng/calendar";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SplitterModule } from "primeng/splitter";
import { TreeModule } from "primeng/tree";
import { DataViewModule } from "primeng/dataview";
import { DropdownModule } from "primeng/dropdown";
import { ImageModule } from "primeng/image";
import { ProgressBarModule } from "primeng/progressbar";
import { TagModule } from "primeng/tag";
import { DividerModule } from "primeng/divider";
import { FieldsetModule } from "primeng/fieldset";
import { TreeSelectModule } from "primeng/treeselect";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { MenuModule } from "primeng/menu";
import { ContextMenuModule } from "primeng/contextmenu";
import { RippleModule } from "primeng/ripple";
import { TooltipModule } from "primeng/tooltip";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";

// Interface for tracking file upload state
interface FileUploadState {
    file: File;
    documentId?: number; // Temporary ID for tracking
    fileName: string;
    progress: number;
    status: 'uploading' | 'success' | 'error';
    error?: string;
    uploadResponse?: FichierUpload | VideoUpload | R2Upload | ErrorUpload;
    documentEntity?: DocumentEntite;
    hash: string;
}

@Component({
    standalone: true,
    selector: 'app-document',
    styleUrl: './document.component.scss',
    templateUrl: './document.component.html',
    providers: [ConfirmationService],
    imports: [
        CommonModule, FormsModule, ButtonModule, ToastModule, ConfirmDialogModule, SidebarModule, CalendarModule,
        CardModule, ProgressSpinnerModule, SplitterModule, TreeModule, DataViewModule, DropdownModule,
        ImageModule, ProgressBarModule, TagModule, DividerModule, FieldsetModule, TreeSelectModule,
        ConfirmPopupModule, MenuModule, ContextMenuModule, RippleModule, TooltipModule,
        InputTextModule, InputTextareaModule
    ]
})
export class DocumentComponent extends BaseComponent implements OnInit {
    @Input({ required: true }) typeLienDocument: ETypeLien;
    @Input({ required: true }) idLien: number;
    @Input({ required: true }) numero: string;
    @Input() showFolders: boolean = true;
    @Input() readonly: boolean = false;
    @Input() canAddDocument: boolean = true;
    @Input() public: boolean = false;
    @Input() rows: WritableSignal<number> = this.createLocalStorageSignal('document_rows', 8);
    @Input() mandatoryDescription: boolean = false;
    @Input()
    get selectedTreeNode(): string {
        return this.selectionTypeDocument()?.data;
    }

    set selectedTreeNode(newValue: string) {
        if (this.typesDocuments == undefined)
            return;

        this.typesDocuments.forEach(type => {
            if (type.data == newValue)
                this.selectionTypeDocument.set(type);
        });

        this.menudossiers.scrollTo(this.selectionTypeDocument());
    }

    drawerVisible: boolean = false;
    isDraggingOver: boolean = false;

    // Cache for pre-generated URLs to improve drag performance
    private urlCache: Map<number, string> = new Map();

    selectionTypeDocument: WritableSignal<TreeNode> = signal(null);
    typesDocuments: TreeNode[] = [];
    documentsComplet: WritableSignal<DocumentEntite[]> = signal([]);
    documentsFiltres: Signal<DocumentEntite[]> = computed(() => {
        let documents = this.documentsComplet();

        if (this.selectionTypeDocument() != null) {
            if ((this.selectionTypeDocument() as FileTreeNode).isRootFolder) {
                documents = documents.filter(doc => {
                    const pathSegments = doc.cheminFichier.split('/').slice(2, -1);
                    return pathSegments[0] === this.selectionTypeDocument()?.data && pathSegments.length == 1;
                });
            } else {
                documents = documents.filter(doc => {
                    const pathSegments = doc.cheminFichier.split('/').slice(3, -1);

                    return this.selectionTypeDocument()?.data.endsWith(pathSegments[pathSegments.length - 1]);
                });
            }
        }

        if (this.searchText() != null && this.searchText() != '') {
            documents = documents.filter(doc =>
                doc.nom ? doc.nom.toLowerCase().includes(this.searchText().toLowerCase()) : true ||
                    doc.dossier ? doc.dossier.toLowerCase().includes(this.searchText().toLowerCase()) : true
            );
        }

        documents.sort((a, b) => {
            if ((a[this.sortField()] + "").localeCompare(b[this.sortField()] + "") == 0)
                return 0 * this.sortOrder();
            else if ((a[this.sortField()] + "").localeCompare(b[this.sortField()] + "") > 0)
                return 1 * this.sortOrder();
            else
                return -1 * this.sortOrder();
        });

        //documents = documents.slice(this.first(), this.first() + this.rows());

        documents.slice(this.first(), this.first() + this.rows()).forEach(doc => {
            if (!doc.apercu && doc.typeFichier == ETypeFichier.Image && doc.indCloudflare) {
                this.obtenirApercu(doc);
            }
        });

        return documents;
    });
    dossierFiltres = computed(() => {
        return this.selectionTypeDocument()?.children?.filter(x => x.type == 'folder') ?? []
    })
    contenuMenuContextuelDocuments: MenuItem[];
    contenuMenuContextuelFichiers: MenuItem[];
    contenuMenuAjoutDocument: MenuItem[] = [
        {
            label: 'Dossiers',
            icon: 'pi pi-folder',
            command: () => {
                this.submitted = true;
                if (this.valider()) {
                    this.folderInput.nativeElement.click();
                }
            }
        },
        {
            label: 'Fichiers',
            icon: 'pi pi-file',
            command: () => {
                this.submitted = true;
                if (this.valider()) {
                    this.fileInput.nativeElement.click();
                }
            }
        }
    ];
    requeteAjouterDocuments: RequeteAjouterDocuments;
    selectedTreeSelectNode: TreeNode;
    layout: Signal<string> = this.createLocalStorageSignal('document_layout', 'grid');
    sortField: WritableSignal<string> = signal('!date');
    sortOrder: WritableSignal<number> = signal(1);
    sortOptions: any[];
    first: WritableSignal<number> = signal(0);
    searchText: WritableSignal<string> = signal('');
    submitted: boolean = false;
    visibleSidebarAjoutDocument: boolean = false;

    @ViewChild('optionsmenu') options;
    @ViewChild('menuContextuelFichiers') menuContextuelFichiers;
    @ViewChild('menudossiers') menudossiers: Tree;
    @ViewChild('dv') dataview: DataView;
    @ViewChild('sidebarAjoutDocument') sidebarAjoutDocument: Sidebar;
    @ViewChild('fileInput') fileInput: ElementRef;
    @ViewChild('folderInput') folderInput: ElementRef;

    // Upload tracking
    uploadingFiles: Map<number, FileUploadState> = new Map();
    uploadBatchId: number = 0;
    nextTempDocId: number = -1; // Negative IDs for temporary documents  

    files: WritableSignal<File[]> = signal([]);

    constructor(
        private contexteService: ContexteService,
        public routerService: Router,
        @Optional() public sdb: DonneesBaseService,
        public profilService: ProfilService,
        public route: ActivatedRoute,
        @Optional() public appMain: AppMainComponent,
        public messageService: MessageService,
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public itemService: ItemService,
        public documentService: DocumentService,
        public notificationService: NotificationService,
        @Optional() private ref: DynamicDialogRef,
        @Optional() private config: DynamicDialogConfig

    ) {
        super(sdb, profilService, route, routerService, appMain);
    }

    ngOnInit() {
        if (this.config && this.config?.data?.typeLienDocument) {
            this.typeLienDocument = this.config.data.typeLienDocument;
            this.idLien = this.config.data.idLien;
            this.showFolders = this.config.data.showFolders;
            this.canAddDocument = this.config.data.canAddDocument;
        }

        this.requeteAjouterDocuments = {
            typeLien: this.typeLienDocument,
            idLien: this.idLien,
            date: new Date(),
            path: undefined,
            documents: []
        };

        if (!this.public) {
            this.documentService.ObtenirListeDocuments(this.typeLienDocument, parseInt(this.idLien.toString())).subscribe({
                next: (res) => {
                    this.buildFileTree(res.body.documents);
                },
                error: (err) => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors du chargement des documents' });
                }
            });
        } else {
            this.documentService.ObtenirDocumentsPublics(this.route.snapshot.params['uuid']).subscribe({
                next: (res) => {
                    this.sdb.SyncroniserTypesDocument().then(() => {
                        this.buildFileTree(res.body.documents);
                    }).catch(() => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors du chargement des documents' });
                    });
                }
            });
        }


        this.sortOptions = [
            { label: 'Date du plus récent au plus ancien', value: '!date' },
            { label: 'Date du plus ancien au plus récent', value: 'date' },
            { label: 'Nom ascendant', value: 'nom' },
            { label: 'Nom descendant', value: '!nom' },
        ];
    }

    onSortChange(event) {
        if (event.value.indexOf('!') == 0) {
            this.sortField.set(event.value.substring(1));
            this.sortOrder.set(-1);
        } else {
            this.sortField.set(event.value);
            this.sortOrder.set(1);
        }
    }

    buildFileTree(documents: DocumentEntite[]) {
        this.DemarrerChargement();
        this.urlCache.clear();

        if (documents) {
            documents = documents.map(doc => {
                if (doc.typeFichier == ETypeFichier.Pdf)
                    doc.apercu = 'data:application/jpeg;base64,' + "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";
                return doc
            });

            this.documentsComplet.set(documents);

            const rootFolders = this.sdb.TypesDocumentsParTypeLien(this.typeLienDocument);

            for (const rootFolder of rootFolders) {
                this.buildFolder(this.typesDocuments, rootFolder.nom, rootFolder.dossier, true);
            }

            for (const file of documents) {
                this.addFile(file);
            }

            if (this.typeLienDocument == ETypeLien.ActionCorrective) {
                this.selectionTypeDocument.set(this.typesDocuments[0].children.find(x => x.data == 'action_corrective'));
                this.menudossiers.scrollTo(this.selectionTypeDocument());
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors du chargement des documents' });
        }

        this.CompleterChargement();
        this.first.set(0);
    }

    addFile(file: DocumentEntite) {
        const pathSegments = file.cheminFichier.split('/').slice(2, -1);
        let node = this.typesDocuments.find(x => x.data == pathSegments[0]);

        if (!node) {
            this.buildFolder(this.typesDocuments, pathSegments[0], pathSegments[0], false);
            node = this.typesDocuments.find(x => x.data == pathSegments[0]);
        }

        for (const segment of pathSegments.slice(1)) {
            if (!node?.children?.find(x => x.data.endsWith(segment))) {
                this.buildFolder(node, segment, pathSegments.slice(0, pathSegments.indexOf(segment) + 1).join('/'), false);
            }

            node = node.children.find(x => x.data.endsWith(segment));
        }

        const fileNode: FileTreeNode = {
            label: file.nomFichier,
            data: file.documentId.toString(),
            icon: this.getFileIcon(file.typeFichier),
            type: 'file',
            document: file,
            draggable: true,
            parent: node
        };

        node.children.push(fileNode);
    }

    buildFolder(node: FileTreeNode | TreeNode<any> | TreeNode[], name: string, key: string, isRootFolder: boolean = false) {
        const folderNode: FileTreeNode = {
            label: name + (this.obtenirNombreDocumentsParDossier(key, isRootFolder) > 0 ? ' (' + this.obtenirNombreDocumentsParDossier(key, isRootFolder) + ')' : ''),
            data: key,
            expandedIcon: 'pi pi-folder-open',
            collapsedIcon: 'pi pi-folder',
            children: [],
            type: 'folder',
            isRootFolder: isRootFolder
        };

        if (node instanceof Array) {
            node.push(folderNode);
        } else {
            node.children.push(folderNode);
        }
    }

    onSelectionDocument(event) {
        if (event.node && event.node.type === 'file' && event.node.parent) {
            this.selectionTypeDocument.set(event.node.parent);
        } else if (event.node && event.node.type === 'folder') {
            this.selectionTypeDocument.set(event.node);
        }

        if (this.selectionTypeDocument()?.parent) {
            this.selectionTypeDocument()?.parent.children.forEach(folder => {
                folder.expanded = false;
            });
        }

        this.selectionTypeDocument.update(x => { x.expanded = true; return x; });
        this.first.set(0);
    }

    getTypeDocument(path: string): TypeDocumentEntite | undefined {
        if (path == null) return undefined;
        if (path.split('/').length > 0) {
            return this.sdb.TypesDocumentsParTypeLien(this.typeLienDocument).find(x => x.dossier == path.split('/')[0]);
        }
        return undefined;
    }

    ajouterDocument(event: Event) {
        if (this.hasActiveUploads()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Téléchargement en cours',
                detail: 'Veuillez attendre que les téléchargements en cours soient terminés avant d\'ajouter de nouveaux documents.',
                life: 3000
            });
            return;
        }

        this.submitted = false;
        this.requeteAjouterDocuments = {
            typeLien: this.typeLienDocument,
            idLien: this.idLien,
            date: new Date(),
            path: this.selectionTypeDocument()?.data,
            documents: []
        };

        setTimeout(() => {
            this.visibleSidebarAjoutDocument = true;
        }, 0);
    }

    valider(): boolean {
        if (!this.requeteAjouterDocuments.date || (!this.selectionTypeDocument() && this.showFolders)) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Vous devez remplir tous les champs.', life: 3000 });
            return false;
        }

        return true;
    }

    modifierDocument(doc: any) {
        const ref = this.dialogService.open(DetailDocumentComponent, {
            data: {
                document: doc,
                typeLien: this.typeLienDocument,
                idLien: this.idLien
            },
            header: 'Modifier un document',
            width: '60%'
        }).onClose.subscribe((res: DocumentEntite) => {
            if (res) {
                this.documentsComplet.set(this.documentsComplet().map(x => x.documentId == doc.documentId ? res : x));
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Document modifié.` });
            }
        });
    }

    supprimerDocument(doc: any) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Voulez-vous vraiment supprimer le document sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => {
                this.documentService.SupprimerDocument(doc.documentId).then(res => {
                    if (res.estUnSucces) {
                        this.documentsComplet.set(this.documentsComplet().filter(x => x.documentId != doc.documentId));
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Document supprimé.' });
                        this.first.set(0);
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    afficherImage(doc: DocumentEntite) {
        if (doc.typeFichier == ETypeFichier.Pdf)
            return doc.apercu;
        else
            return this.documentService.ObtenirApercuCloudflare(doc.cheminFichier);
    }

    loadPreviewImage(doc: DocumentEntite) {
        if (!doc.previewUrl) {
            if (doc.typeFichier === ETypeFichier.Pdf) {
                this.dialogService.open(PdfViewerComponent, {
                    data: {
                        document: doc
                    },
                    header: 'Aperçu du PDF',
                    width: '90%',
                    height: '90%',
                    maximizable: true,
                    resizable: true
                });

                const previewContainer = document.querySelector('.p-image-mask') as HTMLElement;
                if (previewContainer) {
                    previewContainer.style.display = 'none';
                }
                return;
            }


            try {
                if (doc.indCloudflare) {
                    this.documentService.ObtenirApercuCloudflare(doc.cheminFichier).subscribe({
                        next: res => {
                            if (res.type === HttpEventType.Response) {
                                doc.previewUrl = URL.createObjectURL(res.body);
                            }
                        }
                    });
                }
            } catch (error) {
                console.error('Error loading preview:', error);
            }
        }
    }

    async telechargerDocument(doc: any) {
        var progress = this.notificationService.showUploadProgress(doc.nomFichier, 0, () => this.telechargerDocument(doc));
        this.documentService.ObtenirApercuCloudflare(doc.cheminFichier).subscribe({
            next: res => {
                if (res.type === HttpEventType.DownloadProgress) {
                    progress.next({ progress: Math.round(res.loaded / res.total * 100), success: null });
                }
                if (res.type === HttpEventType.Response) {
                    const imageURL = URL.createObjectURL(res.body);
                    const link = document.createElement('a')
                    link.href = imageURL
                    link.download = doc.nomFichier
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    progress.next({ progress: 100, success: true });
                }
            },
            error: err => {
                progress.next({ progress: 100, success: false });
            }
        });
    }

    surMenuContextuelDocuments(event, doc: DocumentEntite) {
        this.contenuMenuContextuelDocuments = [
            {
                label: 'Copier l\'URL publique',
                icon: 'pi pi-copy',
                visible: doc.public,
                command: () => this.copierUrlPublique(doc)
            },
            {
                label: 'Modifier ou voir',
                icon: 'pi pi-pencil',
                command: () => this.modifierDocument(doc)
            },
            {
                label: 'Marquer comme image principale',
                icon: 'pi pi-image',
                visible: !doc.indPrincipale && this.typeLienDocument == ETypeLien.Item && doc.typeFichier == ETypeFichier.Image,
                command: () => this.marquerImagePrincipale(doc)
            },
            {
                label: 'Retirer comme image principale',
                icon: 'pi pi-image',
                visible: doc.indPrincipale && this.typeLienDocument == ETypeLien.Item,
                command: () => this.retirerImagePrincipale(doc)
            },
            {
                separator: true
            },
            {
                label: 'Supprimer',
                icon: 'pi pi-trash',
                command: () => this.supprimerDocument(doc)
            }
        ];
        this.options.toggle(event);
    }

    onLazyLoad(event: LazyLoadEvent) {
        this.rows.set(event.rows);
        this.first.set(event.first);
        this.sortField.set(event.sortField);
        this.sortOrder.set(event.sortOrder);
        this.searchText.set(event.filters?.global?.value || '');
    }

    obtenirNombreDocumentsParDossier(dossier: string, isRootFolder: boolean = false) {
        // For root folders, count all files in that folder (including all subfolders)
        if (isRootFolder) {
            return this.documentsComplet().filter(doc => {
                const pathSegments = doc.cheminFichier.split('/').slice(2, -1);
                return pathSegments[0] === dossier && pathSegments.length == 1;
            }).length;
        } else {
            return this.documentsComplet().filter(doc => {
                const pathSegments = doc.cheminFichier.split('/').slice(3, -1);
                return pathSegments[pathSegments.length - 1] === dossier;
            }).length;
        }
    }

    obtenirApercu(doc: DocumentEntite) {
        doc.loading = true;
        this.documentService.ObtenirApercuCloudflare(doc.cheminFichier, 300).subscribe({
            next: res => {
                if (res.type === HttpEventType.Response) {
                    doc.apercu = URL.createObjectURL(res.body);
                    doc.loading = false;
                }
            },
            error: err => {
                doc.loading = false;
            }
        });
    }

    afficherVideo(doc: any) {
        this.dialogService.open(VideoPlayerComponent, {
            data: {
                document: doc
            },
            header: 'Aperçu de la vidéo',
            width: this.isMobile ? '100%' : '60%'
        });
    }

    copierUrlPublique(doc: any) {
        const publicUrl = `${environment.cloudflare.url}${doc.cheminFichier}`;
        navigator.clipboard.writeText(publicUrl)
            .then(() => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'URL publique copiée dans le presse-papier' });
            });
    }

    marquerImagePrincipale(doc: DocumentEntite) {
        var ancienneImagePrincipale = this.documentsComplet().find(x => x.indPrincipale);

        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment marquer cette image comme principale? ' + (ancienneImagePrincipale ? `L'ancienne image principale sera remplacée (${ancienneImagePrincipale.nom}).` : ''),
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept: () => {
                this.messageService.add({ severity: 'info', summary: 'Information', detail: 'Marquage en cours...' });
                this.itemService.MarquerPhotoPrincipale(this.idLien, doc.documentId).subscribe({
                    next: res => {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Image principale marquée. Veillez rafraîchir la page pour voir la nouvelle image principale.' });
                        let documents = this.documentsComplet();
                        documents.find(x => x.documentId == doc.documentId).indPrincipale = true;
                        if (ancienneImagePrincipale) {
                            documents.find(x => x.documentId == ancienneImagePrincipale.documentId).indPrincipale = false;
                        }
                        this.documentsComplet.set(documents);
                    }
                });
            }
        });
    }

    retirerImagePrincipale(doc: DocumentEntite) {
        this.itemService.RetirerPhotoPrincipale(this.idLien).subscribe({
            next: res => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Image principale retirée' });
                let documents = this.documentsComplet();
                documents.find(x => x.documentId == doc.documentId).indPrincipale = false;
                this.documentsComplet.set(documents);
            }
        });
    }

    getFileIcon(typeFichier: ETypeFichier): string {
        switch (typeFichier) {
            case ETypeFichier.Pdf:
                return 'pi pi-file-pdf';
            case ETypeFichier.Image:
                return 'pi pi-image';
            case ETypeFichier.Video:
                return 'pi pi-video';
            case ETypeFichier.Autre:
            default:
                return 'pi pi-file';
        }
    }



    ouvrirFichier(doc: DocumentEntite) {
        // Check if it's an image, video, or PDF - open fullscreen
        if (doc.typeFichier === ETypeFichier.Image) {
            this.loadPreviewImage(doc);
            // Trigger image preview
            setTimeout(() => {
                const imageElement = document.querySelector(`p-image[alt="${doc.nom}"] img`) as HTMLElement;
                if (imageElement) {
                    imageElement.click();
                }
            }, 100);
        } else if (doc.typeFichier === ETypeFichier.Video) {
            this.afficherVideo(doc);
        } else if (doc.typeFichier === ETypeFichier.Pdf) {
            this.dialogService.open(PdfViewerComponent, {
                data: {
                    document: doc
                },
                header: 'Aperçu du PDF',
                width: '90%',
                height: '90%',
                maximizable: true,
                resizable: true
            });
        } else {
            // Download other file types
            this.telechargerDocument(doc);
        }
    }

    onFileRightClick(event: any, node: FileTreeNode) {
        event.preventDefault();
        event.stopPropagation();

        this.surMenuContextuelFichiers(event, node);
    }

    surMenuContextuelFichiers(event: any, node: FileTreeNode) {
        if (node.type === 'file') {
            this.contenuMenuContextuelFichiers = [
                {
                    label: 'Ouvrir',
                    icon: 'pi pi-external-link',
                    command: () => this.ouvrirFichier(node.document)
                },
                {
                    label: 'Copier l\'URL publique',
                    icon: 'pi pi-copy',
                    visible: node.document.public,
                    command: () => this.copierUrlPublique(node.document)
                },
                {
                    label: 'Modifier ou voir',
                    icon: 'pi pi-pencil',
                    command: () => this.modifierDocument(node.document)
                },
                {
                    label: 'Marquer comme image principale',
                    icon: 'pi pi-image',
                    visible: !node.document.indPrincipale && this.typeLienDocument == ETypeLien.Item && node.document.typeFichier == ETypeFichier.Image,
                    command: () => this.marquerImagePrincipale(node.document)
                },
                {
                    label: 'Retirer comme image principale',
                    icon: 'pi pi-image',
                    visible: node.document.indPrincipale && this.typeLienDocument == ETypeLien.Item,
                    command: () => this.retirerImagePrincipale(node.document)
                },
                {
                    label: 'Télécharger',
                    icon: 'pi pi-download',
                    command: () => this.telechargerDocument(node.document)
                },
                {
                    separator: true
                },
                {
                    label: 'Supprimer',
                    icon: 'pi pi-trash',
                    command: () => this.supprimerDocument(node.document)
                }
            ];
        }
        else {
            this.contenuMenuContextuelFichiers = [
                {
                    label: 'Ajouter un document',
                    icon: 'pi pi-plus',
                    command: () => {
                        setTimeout(() => {
                            this.ajouterDocument(event);
                        }, 0);
                    }
                }
            ];
        }
    }

    /**
     * Pre-cache document URLs for better drag performance
     */
    private preCacheDocumentUrls() {
        if (!this.documentsComplet) return;

        // Cache URLs for Cloudflare documents that might be dragged
        const cloudflareDocuments = this.documentsComplet().filter(doc => doc.indCloudflare);

        cloudflareDocuments.forEach(async doc => {
            try {
                const url = `${environment.cloudflare.url}${doc.cheminFichier}`;
                this.urlCache.set(doc.documentId, url);
            } catch (error) {
                console.warn(`Failed to pre-cache URL for document ${doc.documentId}:`, error);
            }
        });
    }

    onFileChange(event: Event) {
        var newFiles = Array.from((event.target as HTMLInputElement).files) as any;

        newFiles.forEach(file => {
            if (this.isImageFile(file)) {
                file.preview = URL.createObjectURL(file);
            }
        });

        this.files.update(files => [...files, ...newFiles]);
    }

    changeFileName(file: File, name: string) {
        var newFile = new File([file], name, { type: file.type });
        if (this.isImageFile(newFile)) {
            (newFile as any).preview = URL.createObjectURL(newFile);
        }
        this.files.update(files => files.map(f => f.name == file.name ? newFile : f));
    }

    ajouterDocuments() {
        if (!this.requeteAjouterDocuments?.date) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Veuillez sélectionner une date' });
            return;
        }

        if (this.sdb.TypesDocumentsParTypeLien(this.typeLienDocument).length !== 0 && !this.selectionTypeDocument()) {
            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Veuillez sélectionner un type de document' });
            return;
        }

        this.visibleSidebarAjoutDocument = false;

        this.initiateUpload();
    }

    /// <summary>
    /// Clean webkitRelativePath of spaces and accents for better file handling
    /// </summary>
    private cleanWebkitRelativePath(path: string): string {
        if (!path) return '';

        return path
            .normalize('NFD') // Decompose accented characters
            .replace(/[\u0300-\u036f]/g, '') // Remove accent marks
            .replace(/\s+/g, '') // Replace spaces with underscores
            .replace(/[^a-zA-Z0-9_\-\.\/]/g, '_'); // Replace other special characters with underscores
    }

    /// <summary>
    /// Check if there are any active uploads in progress
    /// </summary>
    hasActiveUploads(): boolean {
        return this.getUploadingFilesCount() > 0;
    }

    /// <summary>
    /// Get overall upload progress across all uploading files
    /// </summary>
    getOverallUploadProgress(): number {
        if (this.uploadingFiles.size === 0) return 0;

        let totalProgress = 0;
        this.uploadingFiles.forEach(file => {
            totalProgress += file.progress;
        });

        return Math.round(totalProgress / this.uploadingFiles.size);
    }

    /// <summary>
    /// Get count of files by status
    /// </summary>
    getUploadingFilesCount(): number {
        return Array.from(this.uploadingFiles.values()).filter(f => f.status === 'uploading').length;
    }

    getFailedFilesCount(): number {
        return Array.from(this.uploadingFiles.values()).filter(f => f.status === 'error').length;
    }

    getSuccessFilesCount(): number {
        return Array.from(this.uploadingFiles.values()).filter(f => f.status === 'success').length;
    }

    /// <summary>
    /// Get list of failed uploads
    /// </summary>
    getFailedUploads(): FileUploadState[] {
        return Array.from(this.uploadingFiles.values()).filter(f => f.status === 'error');
    }

    /// <summary>
    /// Retry a failed upload
    /// </summary>
    async retryUpload(uploadState: FileUploadState) {
        uploadState.status = 'uploading';
        uploadState.progress = 0;
        uploadState.error = undefined;

        try {
            const fichier: FichierUpload = {
                nom: uploadState.file.name,
                taille: uploadState.file.size,
                date: this.requeteAjouterDocuments?.date,
                description: '',
                chemin: this.cleanWebkitRelativePath(this.getFileFolder(uploadState.file)),
                indPublic: false,
                hash: uploadState.hash,
                type: uploadState.file.type
            };

            const requete: DocumentUpload = {
                typeDocumentId: this.getTypeDocument(this.selectionTypeDocument()?.data)?.typeDocumentId,
                fichiers: [fichier]
            };

            const response = await lastValueFrom(
                this.documentService.initierUploadR2(this.typeLienDocument, this.idLien, requete)
            );

            if ((response.fichiers[0] as ErrorUpload).messageErreur) {
                uploadState.status = 'error';
                uploadState.error = (response.fichiers[0] as ErrorUpload).messageErreur;
                return;
            }

            if (response.fichiers && response.fichiers.length > 0) {
                uploadState.uploadResponse = response.fichiers[0];

                const xhr = await this.uploadFileToPresignedUrl(
                    uploadState.file,
                    (response.fichiers[0] as R2Upload).presignedUrl,
                    (progress) => {
                        uploadState.progress = progress;
                    }
                );

                await this.completeUpload([response.fichiers[0]]);
                uploadState.status = 'success';
                uploadState.progress = 100;
            }
        } catch (error) {
            console.error('Error retrying upload:', error);
            uploadState.status = 'error';
            uploadState.error = error.message || 'Échec de la reprise du téléchargement';
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: `Échec de la reprise: ${uploadState.fileName}`,
                life: 5000
            });
        }
    }

    /// <summary>
    /// Clear completed uploads from the tracker
    /// </summary>
    clearCompletedUploads() {
        const completedIds: number[] = [];
        this.uploadingFiles.forEach((file, id) => {
            if (file.status === 'success') {
                completedIds.push(id);
            }
        });

        completedIds.forEach(id => this.uploadingFiles.delete(id));
    }

    /// <summary>
    /// Dismiss upload progress banner
    /// </summary>
    dismissUploadBanner() {
        this.uploadingFiles.clear();
    }

    /// <summary>
    /// Initiate file upload process
    /// </summary>
    private async initiateUpload() {
        if (!this.files() || this.files().length === 0) return;

        this.uploadBatchId++;
        const batchStartTime = Date.now();

        try {
            // Prepare file metadata
            var fichiers: FichierUpload[] = [];
            const uploadStates: FileUploadState[] = [];

            for (const file of this.files()) {
                const tempDocId = this.nextTempDocId--;

                var hash = await this.documentService.generateFileHash(file);

                const uploadState: FileUploadState = {
                    file: file,
                    documentId: tempDocId,
                    fileName: file.name,
                    progress: 0,
                    status: 'uploading',
                    error: undefined,
                    hash: hash
                };

                uploadStates.push(uploadState);
                this.uploadingFiles.set(tempDocId, uploadState);

                fichiers.push({
                    nom: uploadState.file.name,
                    taille: uploadState.file.size,
                    description: (file as any).description,
                    date: this.requeteAjouterDocuments?.date,
                    chemin: this.cleanWebkitRelativePath(this.getFileFolder(uploadState.file)),
                    indPublic: false,
                    hash: hash,
                    type: file.type
                });
            }

            const requete: DocumentUpload = {
                typeDocumentId: this.getTypeDocument(this.selectionTypeDocument()?.data)?.typeDocumentId,
                fichiers: fichiers
            };

            // Get presigned URLs
            const response = await lastValueFrom(
                this.documentService.initierUploadR2(this.typeLienDocument, this.idLien, requete)
            );

            if (!response || !response.fichiers || response.fichiers.length === 0) {
                throw new Error('Aucune réponse du serveur pour les URL présignées');
            }

            for (const fichier of response.fichiers.filter(f => (f as ErrorUpload).messageErreur)) {
                const uploadState = uploadStates.find(s => s.hash == fichier.hash);
                if (uploadState) {
                    uploadState.status = 'error';
                    uploadState.error = (fichier as ErrorUpload).messageErreur;
                    uploadState.progress = 0;
                }
            }
            fichiers = response.fichiers.filter(f => !(f as ErrorUpload).messageErreur).map(f => {
                const fichier = fichiers.find(f2 => f2.hash == f.hash);
                f.description = fichier?.description;
                return f;
            });

            // Upload files in parallel with progress tracking
            const uploadPromises = fichiers.map(async (uploadResponse, index) => {
                const uploadState = uploadStates.find(s => s.hash == (uploadResponse as FichierUpload).hash);
                uploadState.uploadResponse = uploadResponse as FichierUpload;

                try {
                    if ((uploadResponse as any).$type !== "video") {
                        var responsePresigned = await this.uploadFileToPresignedUrl(
                            uploadState.file,
                            (uploadResponse as R2Upload).presignedUrl,
                            (progress) => {
                                uploadState.progress = progress;
                            }
                        );

                        if (responsePresigned.status >= 200 && responsePresigned.status < 300) {
                            return { uploadResponse, uploadState };
                        } else {
                            throw new Error(responsePresigned.statusText);
                        }
                    } else {
                        var responseVideo = await lastValueFrom(this.documentService.VideoUpload({
                            nomFichier: uploadState.file.name,
                            contenu: await new Promise<string>((resolve, reject) => {
                                const reader = new FileReader();
                                reader.onload = () => resolve((reader.result as string));
                                reader.onerror = reject;
                                reader.readAsDataURL(uploadState.file);
                            }),
                        }));

                        if (responseVideo.status >= 200 && responseVideo.status < 300) {
                            var fichier = fichiers.find(f => f.hash == uploadState.hash);
                            (fichier as VideoUpload).visionnementUrl = responseVideo.body;
                            return { uploadResponse, uploadState };
                        } else {
                            throw new Error(responseVideo.body);
                        }
                    }
                } catch (error) {
                    uploadState.status = 'error';
                    uploadState.error = error.message || 'Échec du téléchargement';
                    uploadState.progress = 0;
                    console.error(`Error uploading file ${uploadState.fileName}:`, error);

                    throw error;
                }
            });

            // Wait for all uploads
            const results = await Promise.allSettled(uploadPromises);

            // Separate successful and failed uploads
            let successfulUploads = results
                .filter(r => r.status === 'fulfilled')
                .map(r => (r as PromiseFulfilledResult<any>).value);

            let failedUploads = results
                .filter(r => r.status === 'rejected')
                .map((r, index) => uploadStates[index]);

            // Complete successful uploads
            if (successfulUploads.length > 0) {
                try {
                    const filesToSend = fichiers.filter(f => successfulUploads.some(upload => upload.uploadState.hash == f.hash));
                    const completlyUploadedFiles = await this.completeUpload(filesToSend);
                    this.documentsComplet.update(docs => [...docs, ...completlyUploadedFiles]);

                    successfulUploads = successfulUploads.filter(upload => completlyUploadedFiles.some(doc => doc.hash == upload.uploadState.hash));
                    failedUploads = filesToSend.filter(f => !completlyUploadedFiles.some(doc => doc.hash == f.hash)).map(f => uploadStates.find(s => s.hash == f.hash));

                    // Update upload states and replace temp documents with real ones
                    successfulUploads.forEach((upload, index) => {
                        const uploadState = upload.uploadState;
                        uploadState.status = 'success';
                        uploadState.progress = 100;
                    });

                    if (successfulUploads.length > 0) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Succès',
                            detail: `${successfulUploads.length} fichier(s) téléchargé(s) avec succès`,
                            life: 3000
                        });
                    }

                    if (failedUploads.length > 0) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Erreur',
                            detail: `${failedUploads.length} fichier(s) ont échoué`,
                            life: 5000
                        });
                    }

                    this.files.set([]);
                } catch (error) {
                    console.error('Error completing uploads:', error);
                    successfulUploads.forEach(upload => {
                        upload.uploadState.status = 'error';
                        upload.uploadState.error = 'Échec de la finalisation du téléchargement';
                    });

                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Échec de la finalisation des téléchargements',
                        life: 5000
                    });
                }
            }

            // Report failed uploads
            if (failedUploads.length > 0) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: `${failedUploads.length} fichier(s) ont échoué`,
                    life: 5000
                });
            }

            // Refresh the view
            this.ngOnInit();

        } catch (error) {
            console.error('Error initiating upload:', error);

            // Mark all uploads in this batch as failed
            this.uploadingFiles.forEach((uploadState) => {
                uploadState.status = 'error';
                uploadState.error = error.message || 'Échec du téléchargement';
                uploadState.progress = 0;
            });

            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Échec de l\'initialisation des téléchargements',
                life: 5000
            });
        }
    }

    /// <summary>
    /// Upload file to presigned URL with progress tracking
    /// </summary>
    private async uploadFileToPresignedUrl(
        file: File,
        presignedUrl: string,
        onProgress?: (progress: number) => void
    ): Promise<XMLHttpRequest> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            // Track upload progress
            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable && onProgress) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    onProgress(percentComplete);
                }
            });

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    if (onProgress) onProgress(100);
                    resolve(xhr);
                } else {
                    reject(new Error(`Échec du téléchargement (status ${xhr.status})`));
                }
            };

            xhr.onerror = () => {
                reject(new Error('Erreur réseau lors du téléchargement'));
            };

            xhr.ontimeout = () => {
                reject(new Error('Délai d\'attente dépassé'));
            };

            xhr.open('PUT', presignedUrl);
            xhr.setRequestHeader('Content-Type', file.type);
            xhr.timeout = 300000; // 5 minutes timeout
            xhr.send(file);
        });
    }

    /// <summary>
    /// Complete upload and register files in database
    /// </summary>
    private async completeUpload(
        fichiers: FichierUpload[] | VideoUpload[] | R2Upload[] | ErrorUpload[]
    ): Promise<DocumentEntite[]> {
        const requete: DocumentUpload = {
            typeDocumentId: this.getTypeDocument(this.selectionTypeDocument()?.data)?.typeDocumentId,
            fichiers: fichiers
        };

        try {
            const documents = await lastValueFrom(
                this.documentService.completerUploadR2(this.typeLienDocument, this.idLien, requete)
            );

            if (documents.status >= 200 && documents.status < 300) {
                return documents.body;
            } else {
                throw new Error(documents.body.toString());
            }
        } catch (error) {
            console.error('Error completing upload:', error);
            throw new Error('Échec de la finalisation du téléchargement: ' + (error.message || ''));
        }
    }

    /// <summary>
    /// Check if a document is currently uploading
    /// </summary>
    isDocumentUploading(doc: DocumentEntite): boolean {
        if (!doc.documentId || doc.documentId > 0) return false;
        return this.uploadingFiles.has(doc.documentId);
    }

    /// <summary>
    /// Get upload progress for a document
    /// </summary>
    getDocumentUploadProgress(doc: DocumentEntite): number {
        if (!doc.documentId || doc.documentId > 0) return 0;
        const uploadState = this.uploadingFiles.get(doc.documentId);
        return uploadState?.progress || 0;
    }

    /// <summary>
    /// Get upload status for a document
    /// </summary>
    getDocumentUploadStatus(doc: DocumentEntite): string {
        if (!doc.documentId || doc.documentId > 0) return '';
        const uploadState = this.uploadingFiles.get(doc.documentId);
        return uploadState?.status || '';
    }

    /// <summary>
    /// Handle folder click in dataview
    /// </summary>
    onFolderClick(folder: any) {
        this.selectionTypeDocument.set(folder);
        this.first.set(0);
    }

    /// <summary>
    /// Find tree node by data value
    /// </summary>
    private findTreeNodeByData(data: string): TreeNode | null {
        if (!this.typesDocuments || !this.typesDocuments[0] || !this.typesDocuments[0].children) {
            return null;
        }

        for (const child of this.typesDocuments[0].children) {
            if (child.data === data) {
                return child;
            }

            // Search in children recursively
            if (child.children) {
                const found = this.findTreeNodeInChildren(child.children, data);
                if (found) return found;
            }
        }

        return null;
    }

    /// <summary>
    /// Recursively search for tree node in children
    /// </summary>
    private findTreeNodeInChildren(children: TreeNode[], data: string): TreeNode | null {
        for (const child of children) {
            if (child.data === data) {
                return child;
            }

            if (child.children) {
                const found = this.findTreeNodeInChildren(child.children, data);
                if (found) return found;
            }
        }
        return null;
    }

    /// <summary>
    /// Check if current selection is in a subfolder (not root)
    /// </summary>
    isInSubfolder(): boolean {
        return this.selectionTypeDocument() != null && !(this.selectionTypeDocument() as FileTreeNode)?.isRootFolder;
    }

    /// <summary>
    /// Navigate to parent folder
    /// </summary>
    goToParentFolder() {
        let path = this.selectionTypeDocument()?.data?.split('/');

        let parentFolder = null;

        if (path.length > 1) {
            path.pop();
            for (const segment of path) {
                if (parentFolder?.children) {
                    parentFolder = parentFolder?.children?.find(x => x.data.endsWith(segment));
                }
                else {
                    parentFolder = this.typesDocuments.find(x => x.data == segment);
                }
            }

            if (parentFolder) {
                this.selectionTypeDocument.set(parentFolder);
                this.first.set(0);
            }
        }
    }

    /// <summary>
    /// Clear all files from the upload queue
    /// </summary>
    clearAllFiles() {
        this.files.set([]);
    }

    /// <summary>
    /// Check if a file is an image
    /// </summary>
    isImageFile(file: File): boolean {
        return file.type.startsWith('image/') || /\.svg$/i.test(file.name);
    }

    /// <summary>
    /// Get preview URL for image files
    /// </summary>
    getFilePreview(file: File): string {
        return URL.createObjectURL(file);
    }

    /// <summary>
    /// Get folder path from webkitRelativePath
    /// </summary>
    getFileFolder(file: File): string {
        const webkitPath = (file as any).webkitRelativePath;
        if (!webkitPath) return '';

        const pathParts = webkitPath.split('/');
        if (pathParts.length <= 1) return '';

        // Return all parts except the filename
        return pathParts.slice(0, -1).join(' / ');
    }

    /// <summary>
    /// Get file name without extension
    /// </summary>
    getFileNameWithoutExtension(file: File): string {
        const name = file.name;
        const lastDotIndex = name.lastIndexOf('.');
        return lastDotIndex > 0 ? name.substring(0, lastDotIndex) : name;
    }

    /// <summary>
    /// Remove a file from the upload queue
    /// </summary>
    removeFile(index: number) {
        const updatedFiles = this.files().filter((_, i) => i !== index);
        this.files.set(updatedFiles);
    }

    /// <summary>
    /// Track files by index to prevent DOM recreation when file name changes
    /// </summary>
    trackByIndex(index: number, file: File): number {
        return index;
    }

    /// <summary>
    /// Format file size in human readable format
    /// </summary>
    formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }

    /// <summary>
    /// Handle files dropped on the dataview area. Opens the add file sidebar and adds dropped files to the upload list.
    /// </summary>
    onFilesDropped(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (this.readonly || !this.canAddDocument) {
            return;
        }

        if (this.hasActiveUploads()) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Téléchargement en cours',
                detail: 'Veuillez attendre que les téléchargements en cours soient terminés avant d\'ajouter de nouveaux documents.',
                life: 3000
            });
            return;
        }

        const droppedFiles = event.dataTransfer?.files;
        if (!droppedFiles || droppedFiles.length === 0) {
            return;
        }

        // Initialize the request if sidebar is not already open
        if (!this.visibleSidebarAjoutDocument) {
            this.submitted = false;
            this.requeteAjouterDocuments = {
                typeLien: this.typeLienDocument,
                idLien: this.idLien,
                date: new Date(),
                path: this.selectionTypeDocument()?.data,
                documents: []
            };
        }

        // Convert FileList to array and add previews for images
        const newFiles = Array.from(droppedFiles) as any[];
        newFiles.forEach(file => {
            if (this.isImageFile(file)) {
                file.preview = URL.createObjectURL(file);
            }
        });

        // Add files to the upload list
        this.files.update(files => [...files, ...newFiles]);

        // Open the sidebar
        this.visibleSidebarAjoutDocument = true;
        this.isDraggingOver = false;
    }

    /// <summary>
    /// Handle dragover event on the dataview area to enable drop
    /// </summary>
    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.readonly && this.canAddDocument && !this.hasActiveUploads()) {
            this.isDraggingOver = true;
        }
    }

    /// <summary>
    /// Handle dragleave event on the dataview area
    /// </summary>
    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.isDraggingOver = false;
    }

    get ETypeFichier() {
        return ETypeFichier;
    }
}
